import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTourStore } from '@/hooks/useTour';
import { tourSteps } from './tourSteps';
import { TourShowcaseOverlay } from './TourShowcaseOverlay';

export const SpotlightOverlay = () => {
  const { isActive, currentStepIndex, nextStep, endTour } = useTourStore();
  const navigate = useNavigate();
  const location = useLocation();

  const currentStep = tourSteps[currentStepIndex];
  const isLastStep = currentStepIndex === tourSteps.length - 1;

  useEffect(() => {
    if (!isActive || !currentStep) return;

    // Skip navigation for showcase steps - they render demo content and don't need the real page
    if (currentStep.showcaseSlides) return;

    // Navigate to required route if specified (only for non-showcase steps)
    if (currentStep.route && location.pathname !== currentStep.route) {
      navigate(currentStep.route);
    }
  }, [isActive, currentStepIndex, currentStep, location.pathname, navigate]);

  const handleComplete = async () => {
    // Add haptic feedback
    import('despia-native').then(({ default: despia }) => despia('haptic://')).catch(() => {});

    if (isLastStep) {
      endTour();
      if (currentStep.cta?.route) {
        navigate(currentStep.cta.route);
      }
    } else {
      nextStep();
    }
  };

  if (!isActive || !currentStep) return null;

  // All steps are now showcase type
  if (currentStep.showcaseSlides) {
    return (
      <TourShowcaseOverlay 
        slides={currentStep.showcaseSlides} 
        onComplete={handleComplete} 
      />
    );
  }

  // Fallback - should never reach here with new tour structure
  return null;
};
